<template>
  <div class="passthrough-cell">
    <div class="value-container">
      <span class="value new-body-text">{{ formattedValue }}</span>
      <slot name="after-value" />
      <div class="pass-through-line first" />
      <v-icon
        class="pass-through-arrow first"
        size="10px"
        icon="$arrow-right"
      />
    </div>
    <div class="percentage">
      <span v-if="typeof percent === 'string' && parseInt(percent, 10) > 0">
        {{ percent }}%
      </span>
      <div class="pass-through-line" />
      <v-icon
        class="pass-through-arrow"
        size="10px"
        icon="$arrow-right"
      />
    </div>
  </div>
</template>

<script setup>
import { numberWithCommas } from '@/helpers/formatters';
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: Number,
    default: 0,
  },
  percent: {
    type: String,
    default: null,
  },
});

const formattedValue = computed(() => numberWithCommas(props.value));
</script>

<style lang="less" scoped>
.passthrough-cell {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 70px;
  gap: 4px;
}

.value-container {
  display: flex;
  align-items: center;
  position: relative;
}

.value {
  padding: 8.2px 8px;
  color: @text-darkest;
}

.percentage {
  font-size: 11px;
  font-weight: 500;
  color: @text-light;
  display: flex;
  align-items: center;
  padding: 8px 0px;
  position: relative;
}

.pass-through-line {
  position: absolute;
  height: 1px;
  background: @grey-500;
  width: calc(100% - 4px);
  bottom: 3px;

  &:not(.first) {
    width: calc(100% - 2px);
  }
}

.pass-through-arrow {
  position: absolute;
  right: 0px;
  bottom: -1.5px;
  color: @grey-500;
  z-index: 2;

  &:not(.first) {
    right: -2px;
  }
}
</style>
